<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="show"
        class="fixed inset-0 z-50 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <!-- Overlay -->
        <div
          class="fixed inset-0 backdrop-blur-sm transition-opacity"
          @click="handleClose"
        />

        <!-- Modal Container -->
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <!-- Modal -->
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full relative z-10">
            <!-- Header -->
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="flex items-start">
                <div class="mt-3 text-center sm:mt-0 sm:text-left w-full">
                  <h3 id="modal-title" class="text-lg leading-6 font-medium text-gray-900 mb-4">
                    Conditions d'utilisation
                  </h3>
                  
                  <div class="mt-2 max-h-96 overflow-y-auto">
                    <div class="text-sm text-gray-500 space-y-4">
                      <p>
                        <strong>1. Acceptation des conditions</strong><br>
                        En utilisant la plateforme Anamnesis, vous acceptez d'être lié par ces conditions d'utilisation.
                      </p>
                      
                      <p>
                        <strong>2. Description du service</strong><br>
                        Anamnesis est une plateforme dédiée à la gestion et à la documentation du patrimoine culturel et archéologique.
                      </p>
                      
                      <p>
                        <strong>3. Compte utilisateur</strong><br>
                        Vous êtes responsable de maintenir la confidentialité de votre compte et de votre mot de passe.
                      </p>
                      
                      <p>
                        <strong>4. Utilisation acceptable</strong><br>
                        Vous vous engagez à utiliser la plateforme de manière légale et respectueuse.
                      </p>
                      
                      <p>
                        <strong>5. Propriété intellectuelle</strong><br>
                        Le contenu de la plateforme est protégé par les droits d'auteur et autres droits de propriété intellectuelle.
                      </p>
                      
                      <p>
                        <strong>6. Limitation de responsabilité</strong><br>
                        La plateforme est fournie "en l'état" sans garantie d'aucune sorte.
                      </p>
                      
                      <p>
                        <strong>7. Modifications</strong><br>
                        Nous nous réservons le droit de modifier ces conditions à tout moment.
                      </p>
                      
                      <p class="text-xs text-gray-400">
                        Dernière mise à jour : 26 mai 2025
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Footer -->
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm transition-colors"
                @click="handleClose"
              >
                J'ai compris
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';

export interface TermsModalProps {
  modelValue: boolean;
}

export interface TermsModalEmits {
  (e: 'update:modelValue', value: boolean): void;
}

const props = defineProps<TermsModalProps>();
const emit = defineEmits<TermsModalEmits>();

const show = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
});

const handleClose = (): void => {
  show.value = false;
};
</script> 